import { Dict } from "src/util/types/global";


type CSSVariableName = `--${string}`;
type CSSVariableValue = `var(${CSSVariableName})`;
export interface IBaseConfig {
    /**
     * Overwrite css variables.
     * Must prefix variable name with `--`.
     */
    variables?: Record<CSSVariableName, CSSVariableValue>;
}

export abstract class BaseConfig<TInterface = IBaseConfig> implements IBaseConfig {
    /**
     * Overwrite css variables
     */
    variables?: Record<CSSVariableName, CSSVariableValue>;

    public constructor(props?: TInterface & IBaseConfig) {
        Object.assign(this, props);
    }

    public useConfig(name: string, theme?: string) {
        const configs = (this.constructor as unknown as Dict<Dict<typeof this>>);
        const themeConfig = theme ? (configs[theme]?.[name] ?? configs["baseTheme"][name]) : configs["baseTheme"][name];
        return themeConfig as typeof this;
    };

    public use<U extends BaseConfig<TInterface>>(this: U, props: Partial<TInterface & IBaseConfig>): U {
        return new (this.constructor as { new(props: Partial<TInterface>): U })({
            ...this,
            ...props,
        });
    }

    static baseTheme: Dict<BaseConfig> & {Default: BaseConfig};
}